import { render, staticRenderFns } from "./CapacityList.vue?vue&type=template&id=5b3eeec8"
import script from "./CapacityList.vue?vue&type=script&lang=js"
export * from "./CapacityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports